import { FormGroup } from "@angular/forms";
import { ViewChild, ComponentFactoryResolver, Directive } from "@angular/core";
import { DialogComponentDirective } from "./dialog-component.directive";
import { DialogChild } from "./dialog-child";
import { LogService } from "../log.service";

@Directive()
export class DialogHost {
    /**
     * Data to pass to the dialog
     */
    protected data: any;

    /**
     * Instance of DialogChild that is hosted by this DialogHost
     */
    protected dialogChild: DialogChild | undefined;

    /**
     * FormGroup instance for the form
     */
    form: FormGroup;

    /** Whether the child dialog can be closed */
    allowClose: boolean = true;

    /** Whether the form is valid */
    isValid: boolean = true;

    /**
     * ViewChild for the component host
     */
    @ViewChild(DialogComponentDirective, { static: true }) componentHost: DialogComponentDirective | undefined;

    /**
     * Create an instance of DialogHost
     * @param data data to display in the dialog
     * @param componentFactoryResolver 
     */
    constructor(data: any, protected componentFactoryResolver: ComponentFactoryResolver, protected logService: LogService) {
        this.form = new FormGroup({});
        this.data = data;
    }

    /**
     * Create the child component inside the host
     */
    protected createComponent() {
        if (this.componentHost) {
            let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.data.component);
            let viewContainerRef = this.componentHost.viewContainerRef;

            viewContainerRef.clear();

            let componentRef = viewContainerRef.createComponent(componentFactory);

            this.dialogChild = <DialogChild>componentRef.instance;
            this.dialogChild.data = this.data.data;

            //
            // All components hosted in this dialog must extend from DialogChild. 
            // Subscribe to the DialogChild's isValid event and update our form
            // to reflect the current state of the child. 
            //
            if (this.dialogChild.isValid != undefined) {
                this.dialogChild.isValid.subscribe((isValid: boolean) => {
                    if (isValid) {
                        this.form.setErrors(null);
                    } else {
                        //
                        // The actual error is not important now.
                        // In the future, it might be necessary to extend isValid to bubble
                        // validation errors.
                        //
                        this.form.setErrors({ 'error': 'errors' });
                    }

                    // Set validity of form.
                    // Using setTimeout, avoids ExpressionChangedAfterItHasBeenCheckedError
                    setTimeout(() => {
                        this.isValid = isValid;
                    });

                });
            }

            //
            // Subscribe to allowClose event and update the view
            //
            if (this.dialogChild.allowClose != undefined) {
                this.dialogChild.allowClose.subscribe((allowClose: boolean) => {
                    this.allowClose = allowClose;
                });
            }
        }
    }
}
